import { render, staticRenderFns } from "./RetornoRecebimento.vue?vue&type=template&id=6fe5d243&"
import script from "./RetornoRecebimento.vue?vue&type=script&lang=js&"
export * from "./RetornoRecebimento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../front-end/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports